import { render, staticRenderFns } from "./UpcomingFixtureActions.vue?vue&type=template&id=586639d4&"
import script from "./UpcomingFixtureActions.vue?vue&type=script&lang=js&"
export * from "./UpcomingFixtureActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports